import { z } from 'zod';
import { tagNameSchema } from './tag';

/** The tag list's path (QZ-D40). */
export const TAGS_PATH = '/tags';

/** The body returned by `GET /tags` (QZ-D40). */
export const listTagsResponseSchema = z
  .object({
    tags: z.array(tagNameSchema),
  })
  .strip();
export type ListTagsResponse = z.infer<typeof listTagsResponseSchema>;

/** The body accepted by `POST /tags` (QZ-D40). */
export const addTagRequestSchema = z
  .object({
    name: tagNameSchema,
  })
  .strict();
export type AddTagRequest = z.infer<typeof addTagRequestSchema>;
